import { useEffect, useState, useRef } from "react";
import {
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import api from "@api";
import "./Messages.css";
import DirectoryNavbar from "../Components/navbar/DirectoryNavbar.jsx";

const Messages = () => {
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [myProfileId, setMyProfileId] = useState(null);
  const [newMessage, setNewMessage] = useState("");
  const navigate = useNavigate();
  const { conversationId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const profileParam = searchParams.get("profile");
  const [showNewMessage, setShowNewMessage] = useState(false);
  const [userSearch, setUserSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [messageRequests, setMessageRequests] = useState([]);
  const [showGroupSettings, setShowGroupSettings] = useState(false);
  const [editingGroupName, setEditingGroupName] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [draftRecipient, setDraftRecipient] = useState(null);
  const [showConversationMenu, setShowConversationMenu] = useState(null);
  const [openMessageMenu, setOpenMessageMenu] = useState(null);
  const [editingMessageId, setEditingMessageId] = useState(null);
  const [editingMessageBody, setEditingMessageBody] = useState("");
  const [showNewMenu, setShowNewMenu] = useState(false);
  const [showNewGroup, setShowNewGroup] = useState(false);
  const [selectedGroupMembers, setSelectedGroupMembers] = useState([]);
  const [showAddMember, setShowAddMember] = useState(false);
  const [showRemoveMember, setShowRemoveMember] = useState(false);
  const newMenuRef = useRef(null);

  useEffect(() => {
    const fetchMyProfile = async () => {
      try {
        const response = await api.get(
          "/api/user-profiles-v2/me"
        );

        setMyProfileId(response.data.profile?.id || null);
      } catch (error) {
        console.error("Error fetching my profile:", error);
        setMyProfileId(null);
      }
    };

    fetchMyProfile();
  }, []);


  useEffect(() => {
    if (!profileParam || users.length === 0) return;

    const profile = users.find(
      (item) =>
        Number(item.id) === Number(profileParam)
    );

    if (!profile) return;

    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete("profile");

    setSearchParams(nextParams, { replace: true });

    handleStartDirectMessage(profile);
  }, [profileParam, users]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        newMenuRef.current &&
        !newMenuRef.current.contains(event.target)
      ) {
        setShowNewMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!selectedConversation?.id) return;

    const fetchLatestMessages = async () => {
      try {
        const response = await api.get(
          `/api/messages/conversation/${selectedConversation.id}`
        );

        setMessages(response.data.messages || []);

        await api.put(
          `/api/messages/conversation/${selectedConversation.id}/read`,
          {}
        );

        window.dispatchEvent(
          new Event("refresh-message-count")
        );
      } catch (error) {
        console.error(
          "Error refreshing messages:",
          error.response?.data || error
        );
      }
    };

    const interval = setInterval(
      fetchLatestMessages,
      3000
    );

    return () => clearInterval(interval);
  }, [selectedConversation?.id]);
  useEffect(() => {
    const fetchMessageRequests = async () => {
      try {
        const response = await api.get(
          "/api/messages/requests"
        );

        setMessageRequests(response.data.requests || []);
      } catch (error) {
        console.error("Error fetching message requests:", error);
        setMessageRequests([]);
      }
    };

    fetchMessageRequests();

    const interval = setInterval(fetchMessageRequests, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const response = await api.get(
          "/api/messages/conversations"
        );

        setConversations(response.data.conversations || []);
      } catch (error) {
        console.error("Error fetching conversations:", error);
      }
    };

    fetchConversations();

    const interval = setInterval(fetchConversations, 3000);

    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    const fetchUsers = async () => {
      if (
        !showNewMessage &&
        !showNewGroup &&
        !showAddMember &&
        !profileParam
      ) return;
      try {
        const response = await api.get(
          "/api/user-profiles-v2"
        );

        setUsers(response.data.profiles || []);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, [showNewMessage, showNewGroup, showAddMember, profileParam]);



  const handleSelectConversation = async (conversation) => {
    setSelectedConversation(conversation);

    try {
      const response = await api.get(
        `/api/messages/conversation/${conversation.id}`
      );

      console.log("Messages response:", response.data);

      setMessages(response.data.messages || []);
      await api.put(
        `/api/messages/conversation/${conversation.id}/read`,
        {}
      );
      window.dispatchEvent(new Event("refresh-message-count"));
      setConversations((prev) =>
        prev.map((item) => {
          if (item.id !== conversation.id) {
            return item;
          }

          return {
            ...item,
            members: item.members?.map((member) =>
              Number(member.user_profile_id) === Number(myProfileId)
                ? {
                  ...member,
                  last_read_at: new Date().toISOString(),
                }
                : member
            ),
          };
        })
      );
    } catch (error) {
      console.error("Error fetching messages:", error);
      setMessages([]);
    }
  };

  useEffect(() => {
    if (!conversationId) {
      setSelectedConversation(null);
      setMessages([]);
      return;
    }

    if (conversations.length === 0) return;

    if (
      Number(selectedConversation?.id) ===
      Number(conversationId)
    ) {
      return;
    }

    const conversation = conversations.find(
      (item) => Number(item.id) === Number(conversationId)
    );

    if (conversation) {
      handleSelectConversation(conversation);
    }
  }, [
    conversationId,
    conversations,
    selectedConversation?.id,
  ]);


  const handleSendMessage = async (e) => {
    e.preventDefault();

    if (!newMessage.trim()) return;

    try {
      let conversation = selectedConversation;

      if (!conversation && draftRecipient) {
        const createResponse = await api.post(
          "/api/messages/direct/create",
          {
            profile_id: draftRecipient.id,
          }
        );

        conversation = createResponse.data.conversation;

        if (!conversation?.id) {
          console.error("Conversation was not created");
          return;
        }

        setSelectedConversation(conversation);
        setDraftRecipient(null);

        setConversations((prev) => [
          conversation,
          ...prev.filter(
            (item) => Number(item.id) !== Number(conversation.id)
          ),
        ]);

        navigate(`/messages/${conversation.id}`);
      }

      if (!conversation?.id) return;

      const response = await api.post(
        "/api/messages/send",
        {
          conversation_id: conversation.id,
          body: newMessage.trim(),
        }
      );

      setMessages((prev) => [
        ...prev,
        response.data.message,
      ]);

      setNewMessage("");
    } catch (error) {
      console.error(
        "Error sending message:",
        error.response?.data || error
      );
    }
  };


  const getConversationName = (conversation) => {
    if (!conversation) {
      if (draftRecipient) {
        const firstName = draftRecipient.first_name || "";
        const lastName = draftRecipient.last_name || "";

        return `${firstName} ${lastName}`.trim() || "Direct Message";
      }

      return "Direct Message";
    }

    if (conversation.type === "group") {
      return conversation.name || "Group Conversation";
    }

    const otherMember = conversation.members?.find(
      (member) =>
        Number(member.user_profile_id) !== Number(myProfileId)
    );

    if (!otherMember?.profile) {
      return "Direct Message";
    }

    const firstName = otherMember.profile.first_name || "";
    const lastName = otherMember.profile.last_name || "";

    return `${firstName} ${lastName}`.trim() || "Direct Message";
  };


  const isConversationUnread = (conversation) => {
    const myMembership = conversation.members?.find(
      (member) =>
        Number(member.user_profile_id) === Number(myProfileId)
    );

    const latestMessage = conversation.messages?.[0];

    if (!latestMessage) return false;

    // Your own message should never make the conversation unread
    if (
      Number(latestMessage.sender_profile_id) ===
      Number(myProfileId)
    ) {
      return false;
    }

    if (!myMembership?.last_read_at) {
      return true;
    }

    return (
      new Date(latestMessage.created_at) >
      new Date(myMembership.last_read_at)
    );
  };

  const filteredUsers = users.filter((profile) => {
    if (Number(profile.id) === Number(myProfileId)) {
      return false;
    }

    const fullName =
      `${profile.first_name || ""} ${profile.last_name || ""}`
        .trim()
        .toLowerCase();

    return fullName.includes(
      userSearch.trim().toLowerCase()
    );
  });

  const filteredGroupUsers = filteredUsers.filter(
    (profile) =>
      !selectedGroupMembers.some(
        (member) => Number(member.id) === Number(profile.id)
      )
  );


  const handleStartDirectMessage = async (profile) => {
    try {
      const response = await api.post(
        "/api/messages/direct",
        {
          profile_id: profile.id,
        }
      );

      const conversation = response.data.conversation;

      if (conversation?.id) {
        setDraftRecipient(null);

        setConversations((prev) => {
          const alreadyExists = prev.some(
            (item) => Number(item.id) === Number(conversation.id)
          );

          if (alreadyExists) {
            return prev;
          }

          return [conversation, ...prev];
        });

        setShowNewMessage(false);
        setUserSearch("");

        navigate(`/messages/${conversation.id}`);
        return;
      }

      setDraftRecipient(response.data.recipient);
      setSelectedConversation(null);
      setMessages([]);

      setShowNewMessage(false);
      setUserSearch("");
    } catch (error) {
      console.error(
        "Error starting direct message:",
        error.response?.data || error
      );
    }
  };

  const handleAcceptRequest = async (conversationId) => {
    try {
      await api.put(
        `/api/messages/requests/${conversationId}/accept`,
        {}
      );

      const accepted = messageRequests.find(
        (conversation) => conversation.id === conversationId
      );

      setMessageRequests((prev) =>
        prev.filter((conversation) => conversation.id !== conversationId)
      );

      if (accepted) {
        setConversations((prev) => [accepted, ...prev]);
      }

      navigate(`/messages/${conversationId}`);
    } catch (error) {
      console.error(
        "Error accepting message request:",
        error.response?.data || error
      );
    }
  };

  const handleDeclineRequest = async (conversationId) => {
    try {
      await api.put(
        `/api/messages/requests/${conversationId}/decline`,
        {}
      );

      setMessageRequests((prev) =>
        prev.filter((conversation) => conversation.id !== conversationId)
      );
    } catch (error) {
      console.error(
        "Error declining message request:",
        error.response?.data || error
      );
    }
  };

  const handleLeaveGroup = async () => {
    if (!selectedConversation) return;

    const confirmed = window.confirm(
      "Are you sure you want to leave this group?"
    );

    if (!confirmed) return;

    try {
      await api.delete(
        `/api/messages/group/${selectedConversation.id}/leave`
      );


      setConversations((prev) =>
        prev.filter(
          (conversation) =>
            Number(conversation.id) !== Number(selectedConversation.id)
        )
      );

      setSelectedConversation(null);
      setMessages([]);
      setShowGroupSettings(false);

      navigate("/messages");
    } catch (error) {
      console.error(
        "Error leaving group:",
        error.response?.data || error
      );
    }
  };


  const isGroupAdmin =
    selectedConversation?.type === "group" &&
    Number(selectedConversation.created_by_profile_id) ===
    Number(myProfileId);


  const handleDeleteConversation = async () => {
    if (!selectedConversation) return;

    const confirmed = window.confirm(
      "Delete this conversation from your messages?"
    );

    if (!confirmed) return;

    try {
      await api.delete(
        `/api/messages/conversation/${selectedConversation.id}`
      );
      setConversations((prev) =>
        prev.filter(
          (conversation) =>
            Number(conversation.id) !== Number(selectedConversation.id)
        )
      );

      setSelectedConversation(null);
      setMessages([]);

      navigate("/messages");
    } catch (error) {
      console.error(
        "Error deleting conversation:",
        error.response?.data || error
      );
    }
  };

  const renderMessageBody = (text) => {
    const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (/^(https?:\/\/|www\.)/.test(part)) {
        const href = part.startsWith("www.")
          ? `https://${part}`
          : part;

        return (
          <a
            key={index}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {part}
          </a>
        );
      }

      return part;
    });
  };


  return (
    <div className="messages-page-wrapper">
      <DirectoryNavbar />

      <div className="messages-page">
        <div className="messages-sidebar">
          <div className="messages-sidebar-header">
            <h2>Messages</h2>
            <div ref={newMenuRef}>
              <button
                type="button"
                className="messages-new-button"
                onClick={() => setShowNewMenu((prev) => !prev)}
                aria-label="New message"
              >
                +
              </button>
              {showNewMenu && (
                <div className="messages-new-menu">
                  <button
                    type="button"
                    onClick={() => {
                      setShowNewMenu(false);
                      setShowNewGroup(false);
                      setShowNewMessage(true);
                    }}
                  >
                    New Message
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setShowNewMenu(false);
                      setShowNewMessage(false);
                      setShowNewGroup(true);
                    }}
                  >
                    New Group
                  </button>
                </div>
              )}
            </div>
          </div>
          {messageRequests.length > 0 && (
            <div className="messages-requests-section">
              <div className="messages-requests-title">
                Message Requests
              </div>

              {messageRequests.map((conversation) => {
                const otherMember = conversation.members?.find(
                  (member) =>
                    Number(member.user_profile_id) !== Number(myProfileId)
                );

                const profile = otherMember?.profile;

                const name = profile
                  ? `${profile.first_name || ""} ${profile.last_name || ""
                    }`.trim()
                  : "Unknown";

                return (
                  <div
                    key={conversation.id}
                    className="messages-request-item"
                  >
                    <span>{name}</span>

                    <div className="messages-request-actions">
                      <button
                        type="button"
                        onClick={() => handleAcceptRequest(conversation.id)}
                      >
                        Accept
                      </button>

                      <button
                        type="button"
                        onClick={() => handleDeclineRequest(conversation.id)}
                      >
                        Decline
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {showNewMessage && (
            <div className="messages-new-panel">
              <div className="messages-new-panel-header">
                <span>New Message</span>

                <button
                  type="button"
                  onClick={() => {
                    setShowNewMessage(false);
                    setUserSearch("");
                  }}
                >
                  ×
                </button>
              </div>

              <input
                type="text"
                placeholder="Search players..."
                value={userSearch}
                onChange={(e) => setUserSearch(e.target.value)}
              />
              {userSearch.trim() && (
                <div className="messages-user-results">
                  {filteredGroupUsers.length === 0 ? (
                    <div className="messages-user-empty">
                      No players found
                    </div>
                  ) : (
                    filteredGroupUsers.map((profile) => (
                      <button
                        key={profile.id}
                        type="button"
                        className="messages-user-result"
                        onClick={() =>
                          handleStartDirectMessage(profile)}
                      >
                        <div className="messages-user-avatar">
                          {profile.profile_image ? (
                            <img
                              src={profile.profile_image}
                              alt=""
                            />
                          ) : (
                            <span>
                              {profile.first_name?.charAt(0)}
                              {profile.last_name?.charAt(0)}
                            </span>
                          )}
                        </div>

                        <span>
                          {profile.first_name}{" "}
                          {profile.last_name}
                        </span>
                      </button>
                    ))
                  )}
                </div>
              )}
            </div>
          )}

          {showNewGroup && (
            <div className="messages-new-panel">
              <div className="messages-new-panel-header">
                <span>New Group</span>
                <button
                  type="button"
                  onClick={() => {
                    setShowNewGroup(false);
                    setSelectedGroupMembers([]);
                    setUserSearch("");
                  }}
                >
                  ×
                </button>
              </div>
              {selectedGroupMembers.length > 0 && (
                <div className="messages-selected-members">
                  {selectedGroupMembers.map((member) => (
                    <span key={member.id}>
                      {member.first_name} {member.last_name}

                      <button
                        type="button"
                        onClick={() =>
                          setSelectedGroupMembers((prev) =>
                            prev.filter((item) => item.id !== member.id)
                          )
                        }
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              )}
              <button
                type="button"
                className="messages-create-group-button"
                disabled={selectedGroupMembers.length < 1}
                onClick={async () => {
                  try {
                    const response = await api.post(
                      "/api/messages/group",
                      {
                        member_profile_ids: selectedGroupMembers.map(
                          (member) => member.id
                        ),
                      }
                    );

                    const newConversation = {
                      ...response.data.conversation,
                      members: response.data.members,
                    };

                    setConversations((prev) => [
                      newConversation,
                      ...prev,
                    ]);

                    setShowNewGroup(false);
                    setSelectedGroupMembers([]);
                    setUserSearch("");

                    navigate(`/messages/${newConversation.id}`);
                  } catch (error) {
                    console.error(
                      "Error creating group:",
                      error.response?.data || error
                    );
                  }
                }}
              >
                Create Group
              </button>
              <input
                type="text"
                placeholder="Search players..."
                value={userSearch}
                onChange={(e) => setUserSearch(e.target.value)}
              />
              {userSearch.trim() && (
                <div className="messages-user-results">
                  {filteredGroupUsers.length === 0 ? (
                    <div className="messages-user-empty">
                      No players found
                    </div>
                  ) : (
                    filteredGroupUsers.map((profile) => (
                      <button
                        key={profile.id}
                        type="button"
                        className="messages-user-result"
                        onClick={() => {
                          setSelectedGroupMembers((prev) =>
                            prev.some((member) => member.id === profile.id)
                              ? prev.filter((member) => member.id !== profile.id)
                              : [...prev, profile]
                          );

                          setUserSearch("");
                        }}
                      >
                        <div className="messages-user-avatar">
                          {profile.profile_image ? (
                            <img
                              src={profile.profile_image}
                              alt=""
                            />
                          ) : (
                            <span>
                              {profile.first_name?.charAt(0)}
                              {profile.last_name?.charAt(0)}
                            </span>
                          )}
                        </div>

                        <span>
                          {profile.first_name} {profile.last_name}
                        </span>
                      </button>
                    ))
                  )}
                </div>
              )}
            </div>
          )}

          <div className="messages-conversation-list">
            {conversations.length === 0 ? (
              <p>No conversations yet.</p>
            ) : (
              conversations.map((conversation) => (
                <div
                  key={conversation.id}
                  className={`messages-conversation-item ${selectedConversation?.id === conversation.id ? "active" : ""
                    }`}
                  onClick={() => {
                    navigate(`/messages/${conversation.id}`);
                  }}
                >
                  <div className="messages-conversation-info">
                    <div className="messages-conversation-person">
                      {conversation.type === "direct" && (() => {
                        const otherMember = conversation.members?.find(
                          (member) =>
                            Number(member.user_profile_id) !== Number(myProfileId)
                        );

                        const profile = otherMember?.profile;

                        if (!profile) return null;

                        return (
                          <button
                            type="button"
                            className="messages-conversation-avatar"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(`/profile/${profile.id}`);
                            }}
                            aria-label={`View ${profile.first_name || "profile"}`}
                          >
                            {profile.profile_image ? (
                              <img
                                src={profile.profile_image}
                                alt=""
                              />
                            ) : (
                              <span>
                                {profile.first_name?.charAt(0)}
                                {profile.last_name?.charAt(0)}
                              </span>
                            )}
                          </button>
                        );
                      })()}

                      <span
                        className={
                          isConversationUnread(conversation)
                            ? "messages-conversation-name unread"
                            : "messages-conversation-name"
                        }
                      >
                        {getConversationName(conversation)}
                      </span>
                    </div>
                    {conversation.type === "direct" && (
                      <button
                        type="button"
                        className="messages-conversation-menu-button"
                        onClick={(e) => {
                          e.stopPropagation();

                          if (
                            Number(selectedConversation?.id) !==
                            Number(conversation.id)
                          ) {
                            navigate(`/messages/${conversation.id}`);
                          }

                          setSelectedConversation(conversation);
                          setShowConversationMenu((prev) =>
                            prev === conversation.id ? null : conversation.id
                          );
                        }}
                      >
                        ⋯
                      </button>
                    )}
                    {showConversationMenu === conversation.id && (
                      <div
                        className="messages-conversation-menu"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <button
                          type="button"
                          onClick={handleDeleteConversation}
                        >
                          Delete Conversation
                        </button>
                      </div>
                    )}
                    {isConversationUnread(conversation) && (
                      <span className="messages-unread-dot" />
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="messages-main">
          {selectedConversation || draftRecipient ? (
            <div className="messages-conversation-panel">
              <div className="messages-conversation-header">
                <div className="messages-conversation-header-top">
                  <div className="messages-conversation-header-left">
                    <button
                      type="button"
                      className="messages-mobile-back"
                      onClick={() => navigate("/messages")}
                    >
                      ←
                    </button>

                    <div>
                      <h3>{getConversationName(selectedConversation)}</h3>

                      {selectedConversation?.type === "group" && (
                        <div className="messages-group-member-count">
                          {selectedConversation.members?.length || 0} members
                        </div>
                      )}
                    </div>
                  </div>

                  {selectedConversation?.type === "group" && (
                    <button
                      type="button"
                      className="messages-group-edit-button"
                      onClick={() =>
                        setShowGroupSettings((prev) => !prev)
                      }
                    >
                      Group Info
                    </button>
                  )}
                </div>
              </div>

              {selectedConversation?.type === "group" &&
                showGroupSettings && (
                  <div className="messages-group-settings">
                    <div className="messages-group-info-members">
                      <div className="messages-group-info-title">
                        Members
                      </div>

                      {selectedConversation.members?.map((member) => {
                        const profile = member.profile;

                        if (!profile) return null;

                        const isAdmin =
                          Number(member.user_profile_id) ===
                          Number(selectedConversation.created_by_profile_id);

                        return (
                          <div
                            key={member.user_profile_id}
                            className="messages-group-info-member"
                          >
                            <div className="messages-group-info-person">
                              <button
                                type="button"
                                className="messages-group-info-avatar"
                                onClick={() => navigate(`/profile/${profile.id}`)}
                                aria-label={`View ${profile.first_name || "profile"}`}
                              >
                                {profile.profile_image ? (
                                  <img
                                    src={profile.profile_image}
                                    alt=""
                                  />
                                ) : (
                                  <span>
                                    {profile.first_name?.charAt(0)}
                                    {profile.last_name?.charAt(0)}
                                  </span>
                                )}
                              </button>

                              <button
                                type="button"
                                className="messages-group-member-link"
                                onClick={() => navigate(`/profile/${profile.id}`)}
                              >
                                {profile.first_name} {profile.last_name}
                              </button>
                            </div>

                            {isAdmin && (
                              <span className="messages-group-admin-label">
                                Admin
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                    {isGroupAdmin && (
                      <>
                        <button
                          type="button"
                          onClick={() => {
                            setGroupName(selectedConversation.name || "");
                            setEditingGroupName(true);
                          }}
                        >
                          Rename Group
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            setShowAddMember((prev) => !prev);
                            setUserSearch("");
                          }}
                        >
                          {showAddMember ? "Cancel" : "Add Member"}
                        </button>
                        {showAddMember && (
                          <div className="messages-add-member-panel">

                            <input
                              type="text"
                              placeholder="Search players..."
                              value={userSearch}
                              onChange={(e) => setUserSearch(e.target.value)}
                            />
                            {userSearch.trim() && (
                              <div className="messages-user-results">
                                {filteredUsers
                                  .filter(
                                    (profile) =>
                                      !selectedConversation.members?.some(
                                        (member) =>
                                          Number(member.user_profile_id) === Number(profile.id)
                                      )
                                  )
                                  .map((profile) => (
                                    <button
                                      key={profile.id}
                                      type="button"
                                      className="messages-user-result"
                                      onClick={async () => {
                                        alert(`Adding ${profile.first_name}`);

                                        try {
                                          const response = await api.post(
                                            `/api/messages/group/${selectedConversation.id}/members`,
                                            {
                                              profile_id: profile.id,
                                            }
                                          );

                                          setSelectedConversation((prev) => ({
                                            ...prev,
                                            members: response.data.members || prev.members,
                                          }));

                                          setConversations((prev) =>
                                            prev.map((conversation) =>
                                              Number(conversation.id) === Number(selectedConversation.id)
                                                ? {
                                                  ...conversation,
                                                  members: response.data.members || conversation.members,
                                                }
                                                : conversation
                                            )
                                          );

                                          setUserSearch("");
                                          setShowAddMember(false);
                                        } catch (error) {
                                          console.error(
                                            "Error adding group member:",
                                            error.response?.data || error
                                          );
                                        }
                                      }}
                                    >
                                      <div className="messages-user-avatar">
                                        {profile.profile_image ? (
                                          <img
                                            src={profile.profile_image}
                                            alt=""
                                          />
                                        ) : (
                                          <span>
                                            {profile.first_name?.charAt(0)}
                                            {profile.last_name?.charAt(0)}
                                          </span>
                                        )}
                                      </div>

                                      <span>
                                        {profile.first_name} {profile.last_name}
                                      </span>
                                    </button>
                                  ))}
                              </div>
                            )}
                          </div>
                        )}

                        <button
                          type="button"
                          onClick={() => {
                            setShowRemoveMember((prev) => !prev);
                          }}
                        >
                          {showRemoveMember ? "Cancel" : "Remove Member"}
                        </button>
                        {showRemoveMember && (
                          <div className="messages-remove-member-panel">
                            {selectedConversation.members
                              ?.filter(
                                (member) =>
                                  Number(member.user_profile_id) !==
                                  Number(selectedConversation.created_by_profile_id)
                              )
                              .map((member) => {
                                const profile = member.profile;

                                if (!profile) return null;

                                return (
                                  <button
                                    key={member.user_profile_id}
                                    type="button"
                                    className="messages-user-result"
                                    onClick={async () => {
                                      const confirmed = window.confirm(
                                        `Remove ${profile.first_name} ${profile.last_name} from this group?`
                                      );

                                      if (!confirmed) return;

                                      try {
                                        await api.delete(
                                          `/api/messages/group/${selectedConversation.id}/members/${member.user_profile_id}`
                                        );

                                        setSelectedConversation((prev) => ({
                                          ...prev,
                                          members: prev.members.filter(
                                            (item) =>
                                              Number(item.user_profile_id) !==
                                              Number(member.user_profile_id)
                                          ),
                                        }));

                                        setShowRemoveMember(false);
                                      } catch (error) {
                                        console.error(
                                          "Error removing group member:",
                                          error.response?.data || error
                                        );
                                      }
                                    }}
                                  >
                                    <div className="messages-user-avatar">
                                      {profile.profile_image ? (
                                        <img
                                          src={profile.profile_image}
                                          alt=""
                                        />
                                      ) : (
                                        <span>
                                          {profile.first_name?.charAt(0)}
                                          {profile.last_name?.charAt(0)}
                                        </span>
                                      )}
                                    </div>

                                    <span>
                                      {profile.first_name} {profile.last_name}
                                    </span>
                                  </button>
                                );
                              })}
                          </div>
                        )}
                      </>
                    )}
                    <button
                      type="button"
                      className="messages-delete-group-button"
                      onClick={async () => {
                        const confirmed = window.confirm(
                          "Are you sure you want to permanently delete this group?"
                        );

                        if (!confirmed) return;

                        try {
                          await api.delete(
                            `/api/messages/group/${selectedConversation.id}`
                          );

                          setConversations((prev) =>
                            prev.filter(
                              (conversation) =>
                                Number(conversation.id) !==
                                Number(selectedConversation.id)
                            )
                          );

                          setSelectedConversation(null);
                          setMessages([]);
                          setShowGroupSettings(false);

                          navigate("/messages");
                        } catch (error) {
                          console.error(
                            "Error deleting group:",
                            error.response?.data || error
                          );
                        }
                      }}
                    >
                      Delete Group
                    </button>
                    <button
                      type="button"
                      className="messages-leave-group-button"
                      onClick={handleLeaveGroup}
                    >
                      Leave Group
                    </button>
                  </div>
                )}

              {editingGroupName && (
                <div className="messages-rename-group">
                  <input
                    type="text"
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                    placeholder="Group name"
                  />

                  <button
                    type="button"
                    onClick={async () => {
                      if (!groupName.trim()) return;

                      try {
                        await api.put(
                          `/api/messages/group/${selectedConversation.id}/name`,
                          {
                            name: groupName.trim(),
                          }
                        );

                        setSelectedConversation((prev) => ({
                          ...prev,
                          name: groupName.trim(),
                        }));

                        setConversations((prev) =>
                          prev.map((conversation) =>
                            conversation.id === selectedConversation.id
                              ? {
                                ...conversation,
                                name: groupName.trim(),
                              }
                              : conversation
                          )
                        );

                        setEditingGroupName(false);
                      } catch (error) {
                        console.error(
                          "Error renaming group:",
                          error.response?.data || error
                        );
                      }
                    }}
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    onClick={() => setEditingGroupName(false)}
                  >
                    Cancel
                  </button>
                </div>
              )}
              <div className="messages-thread">
                {messages.length === 0 ? (
                  <p>No messages yet.</p>
                ) : (
                  messages.map((message) => {
                    const isMine =
                      message.sender_profile_id === myProfileId;

                    const senderMember =
                      selectedConversation.members?.find(
                        (member) =>
                          member.user_profile_id ===
                          message.sender_profile_id
                      );

                    const senderName = senderMember?.profile
                      ? `${senderMember.profile.first_name || ""} ${senderMember.profile.last_name || ""
                        }`.trim()
                      : "Unknown";
                    const senderProfile = senderMember?.profile;

                    return (
                      <div
                        key={message.id}
                        className={`messages-message-row ${isMine ? "mine" : "theirs"
                          }`}
                      >
                        <div className="messages-message-content">
                          {!isMine && (
                            <div className="messages-sender-header">
                              {senderProfile && (
                                <button
                                  type="button"
                                  className="messages-thread-avatar"
                                  onClick={() =>
                                    navigate(`/profile/${senderProfile.id}`)
                                  }
                                  aria-label={`View ${senderName}`}
                                >
                                  {senderProfile.profile_image ? (
                                    <img
                                      src={senderProfile.profile_image}
                                      alt=""
                                    />
                                  ) : (
                                    <span>
                                      {senderProfile.first_name?.charAt(0)}
                                      {senderProfile.last_name?.charAt(0)}
                                    </span>
                                  )}
                                </button>
                              )}

                              <div className="messages-sender-name">
                                {senderName}
                              </div>
                            </div>
                          )}
                          {isMine && (
                            <div className="messages-message-menu-wrapper">
                              <button
                                type="button"
                                className="messages-message-menu-button"
                                onClick={() =>
                                  setOpenMessageMenu((prev) =>
                                    prev === message.id ? null : message.id
                                  )
                                }
                              >
                                ⋯
                              </button>

                              {openMessageMenu === message.id && (
                                <div className="messages-message-menu">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setEditingMessageId(message.id);
                                      setEditingMessageBody(message.body);
                                      setOpenMessageMenu(null);
                                    }}
                                  >
                                    Edit Message
                                  </button>

                                  <button
                                    type="button"
                                    onClick={async () => {
                                      try {
                                        await api.delete(
                                          `/api/messages/message/${message.id}`
                                        );

                                        setMessages((prev) =>
                                          prev.filter(
                                            (item) =>
                                              Number(item.id) !== Number(message.id)
                                          )
                                        );

                                        setOpenMessageMenu(null);
                                      } catch (error) {
                                        console.error(
                                          "Error deleting message:",
                                          error.response?.data || error
                                        );
                                      }
                                    }}
                                  >
                                    Delete Message
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                          {editingMessageId === message.id ? (
                            <div className="messages-message-edit">
                              <input
                                type="text"
                                value={editingMessageBody}
                                onChange={(e) => setEditingMessageBody(e.target.value)}
                              />

                              <button
                                type="button"
                                onClick={async () => {
                                  if (!editingMessageBody.trim()) return;

                                  try {
                                    const response = await api.put(
                                      `/api/messages/message/${message.id}`,
                                      {
                                        body: editingMessageBody.trim(),
                                      }
                                    );

                                    setMessages((prev) =>
                                      prev.map((item) =>
                                        Number(item.id) === Number(message.id)
                                          ? response.data.message
                                          : item
                                      )
                                    );

                                    setEditingMessageId(null);
                                    setEditingMessageBody("");
                                  } catch (error) {
                                    console.error(
                                      "Error editing message:",
                                      error.response?.data || error
                                    );
                                  }
                                }}
                              >
                                Save
                              </button>

                              <button
                                type="button"
                                onClick={() => {
                                  setEditingMessageId(null);
                                  setEditingMessageBody("");
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          ) : (
                            <div className="messages-message-bubble">
                              {renderMessageBody(message.body)}
                            </div>
                          )}

                          <div className="messages-message-time">
                            {new Date(
                              message.created_at
                            ).toLocaleTimeString([], {
                              hour: "numeric",
                              minute: "2-digit",
                            })}
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              <form
                className="messages-compose"
                onSubmit={handleSendMessage}
              >
                <input
                  type="text"
                  placeholder="Write a message..."
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                />

                <button type="submit">
                  Send
                </button>
              </form>
            </div>
          ) : (
            <div className="messages-empty-state">
              <h3>Select a conversation</h3>
              <p>Choose a conversation to start messaging.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Messages;